export default {"src":"/_next/static/media/donateur.7b44207b.svg","height":26,"width":43,"blurWidth":0,"blurHeight":0};